export const TERMS_OF_USE_LINK = 'https://www.meetsummer.com/utility/terms';
export const PRIVACY_POLICY_LINK =
  'https://www.meetsummer.com/utility/privacy-policy';
export const CONSUMER_PRIVACY_NOTICE_LINK =
  'https://www.meetsummer.com/utility/consumer-privacy-notice';
export const PAYMENT_TERMS_LINK =
  'https://www.meetsummer.com/utility/payment-terms';
